// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.QuoteSection-container-Yty2n {
	width: 100%;
	max-width: var(--max-container-width);
	margin: 0 auto;
	padding: 0 15px;
}
.QuoteSection-seperator-d731s {
	background-color: var(--primary-border);
	width: 64px;
	display: block;
	height: 1.5px;
	margin: 0 auto;
	margin-bottom: 27px;
}
.QuoteSection-boxseperator-zUFgC {
	height: 2.5px;
	border: 1px solid var(--primary-border);
	background-color: transparent;
}
.QuoteSection-mainhedding-wAriP h1 {
	font-size: 60px;
	line-height: 64px;
	text-align: center;
	font-weight: bold;
	margin-bottom: 73px;
	color: var(--primary-foreground);
}
h4.QuoteSection-common-Tnax2 {
	font-size: 24px;
	font-weight: 800;
	margin-bottom: 20px;
}
p.QuoteSection-common-Tnax2 {
	font-size: 17px;
	line-height: 1.7;
	font-weight: 400;
}
.QuoteSection-quotesection-kmBBB {
	margin-top: 100px;
}
.QuoteSection-contentarea-bZA2s {
	width: 50%;
	display: table-cell;
	vertical-align: middle;
	padding-right: 8%;
}
.QuoteSection-imagearea-MRblM {
	width: 50%;
	display: table-cell;
}
.QuoteSection-contentarea-bZA2s h6 {
	font-size: 18px;
	font-style: italic;
}
.QuoteSection-qutoIcon-YQ6FE {
	height: 33px;
}
span.QuoteSection-qutoSize-eHhoc {
	font-size: 100px;
	color: #FDB32B;
}
.QuoteSection-quotesectionH2-SeeuV {
	font-size: 46px;
}
.QuoteSection-rightsidecontent-DHQp1 {
	padding-left: 8%;
	padding-right: 0%;
}
.QuoteSection-btnlearn-nhJMS {
	border: transparent;
	font-size: 16px;
	padding: 0;
	margin-top: 13px;
	background-color: transparent !important;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
	color: var(--secondary-foreground);
}
.QuoteSection-leftsidecontent-rn4AF {
	padding-left: 0%;
	padding-right: 8%;
}
.QuoteSection-iconCss-b10SG {
	padding-left: 5px;
}
.QuoteSection-imagearea-MRblM img {
	border-radius: 6px;
}
@media screen and (max-width: 991px) {
	h4.QuoteSection-common-Tnax2 {
		font-size: 23px;
		font-weight: 600;
	}

	.QuoteSection-mainhedding-wAriP h1 {
		font-size: 36px;
		line-height: 51px;
		margin-bottom: 13px;
	}

	.QuoteSection-quotesection-kmBBB {
		padding-left: 15px;
		padding-right: 15px;
	}

	.QuoteSection-contentarea-bZA2s h2 {
		font-size: 22px;
	}

	.QuoteSection-contentarea-bZA2s {
		padding-right: 15px;
	}

	.QuoteSection-textarea-HUzCo {
		padding-right: 0px;
		padding-left: 0px;
	}

	.QuoteSection-contentarea-bZA2s h3 {
		height: 25px;
		margin-top: 0px;
	}

	.QuoteSection-centerimgsection-YKibl {
		margin-bottom: 45px;
	}
}
@media screen and (max-width: 767px) {
	.QuoteSection-mainhedding-wAriP h1 {
		font-size: 28px;
		line-height: 51px;
		margin-bottom: 5px;
	}

	h4.QuoteSection-common-Tnax2 {
		font-size: 26px;
	}

	.QuoteSection-quotesectionH2-SeeuV {
		font-size: 25px;
	}

	.QuoteSection-contentarea-bZA2s {
		width: 100%;
		padding-right: 0;
	}

	.QuoteSection-imagearea-MRblM {
		width: 100%;
		display: block;
		margin-top: 35px;
	}

	.QuoteSection-textarea-HUzCo {
		padding-right: 0px;
		padding-left: 0px;
	}

	.QuoteSection-rightsidecontent-DHQp1 {
		padding-left: 0;
		padding-right: 0;
	}

	.QuoteSection-quotesection-kmBBB {
		margin-top: 40px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/QuoteSection/QuoteSection.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,cAAc;CACd,eAAe;AAChB;AAEA;CACC,uCAAuC;CACvC,WAAW;CACX,cAAc;CACd,aAAa;CACb,cAAc;CACd,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,uCAAuC;CACvC,6BAA6B;AAC9B;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,UAAU;CACV,mBAAmB;CACnB,sBAAsB;CACtB,iBAAiB;AAClB;AAEA;CACC,UAAU;CACV,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,kBAAkB;AACnB;AAEA;CACC,YAAY;AACb;AAEA;CACC,gBAAgB;CAChB,cAAc;AACf;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,UAAU;CACV,gBAAgB;CAChB,wCAAwC;CACxC,sCAA8B;SAA9B,8BAA8B;CAC9B,kCAAkC;AACnC;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,YAAY;EACZ,eAAe;CAChB;;CAEA;EACC,mBAAmB;CACpB;AACD;AAEA;CACC;EACC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,iBAAiB;CAClB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;AACD","sourcesContent":["/** RentAll - Begin **/\n.container {\n\twidth: 100%;\n\tmax-width: var(--max-container-width);\n\tmargin: 0 auto;\n\tpadding: 0 15px;\n}\n\n.seperator {\n\tbackground-color: var(--primary-border);\n\twidth: 64px;\n\tdisplay: block;\n\theight: 1.5px;\n\tmargin: 0 auto;\n\tmargin-bottom: 27px;\n}\n\n.boxseperator {\n\theight: 2.5px;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: transparent;\n}\n\n.mainhedding h1 {\n\tfont-size: 60px;\n\tline-height: 64px;\n\ttext-align: center;\n\tfont-weight: bold;\n\tmargin-bottom: 73px;\n\tcolor: var(--primary-foreground);\n}\n\nh4.common {\n\tfont-size: 24px;\n\tfont-weight: 800;\n\tmargin-bottom: 20px;\n}\n\np.common {\n\tfont-size: 17px;\n\tline-height: 1.7;\n\tfont-weight: 400;\n}\n\n.quotesection {\n\tmargin-top: 100px;\n}\n\n.contentarea {\n\twidth: 50%;\n\tdisplay: table-cell;\n\tvertical-align: middle;\n\tpadding-right: 8%;\n}\n\n.imagearea {\n\twidth: 50%;\n\tdisplay: table-cell;\n}\n\n.contentarea h6 {\n\tfont-size: 18px;\n\tfont-style: italic;\n}\n\n.qutoIcon {\n\theight: 33px;\n}\n\nspan.qutoSize {\n\tfont-size: 100px;\n\tcolor: #FDB32B;\n}\n\n.quotesectionH2 {\n\tfont-size: 46px;\n}\n\n.rightsidecontent {\n\tpadding-left: 8%;\n\tpadding-right: 0%;\n}\n\n.btnlearn {\n\tborder: transparent;\n\tfont-size: 16px;\n\tpadding: 0;\n\tmargin-top: 13px;\n\tbackground-color: transparent !important;\n\tbox-shadow: inherit !important;\n\tcolor: var(--secondary-foreground);\n}\n\n.leftsidecontent {\n\tpadding-left: 0%;\n\tpadding-right: 8%;\n}\n\n.iconCss {\n\tpadding-left: 5px;\n}\n\n.imagearea img {\n\tborder-radius: 6px;\n}\n\n@media screen and (max-width: 991px) {\n\th4.common {\n\t\tfont-size: 23px;\n\t\tfont-weight: 600;\n\t}\n\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 13px;\n\t}\n\n\t.quotesection {\n\t\tpadding-left: 15px;\n\t\tpadding-right: 15px;\n\t}\n\n\t.contentarea h2 {\n\t\tfont-size: 22px;\n\t}\n\n\t.contentarea {\n\t\tpadding-right: 15px;\n\t}\n\n\t.textarea {\n\t\tpadding-right: 0px;\n\t\tpadding-left: 0px;\n\t}\n\n\t.contentarea h3 {\n\t\theight: 25px;\n\t\tmargin-top: 0px;\n\t}\n\n\t.centerimgsection {\n\t\tmargin-bottom: 45px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mainhedding h1 {\n\t\tfont-size: 28px;\n\t\tline-height: 51px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\th4.common {\n\t\tfont-size: 26px;\n\t}\n\n\t.quotesectionH2 {\n\t\tfont-size: 25px;\n\t}\n\n\t.contentarea {\n\t\twidth: 100%;\n\t\tpadding-right: 0;\n\t}\n\n\t.imagearea {\n\t\twidth: 100%;\n\t\tdisplay: block;\n\t\tmargin-top: 35px;\n\t}\n\n\t.textarea {\n\t\tpadding-right: 0px;\n\t\tpadding-left: 0px;\n\t}\n\n\t.rightsidecontent {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t}\n\n\t.quotesection {\n\t\tmargin-top: 40px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `QuoteSection-container-Yty2n`,
	"seperator": `QuoteSection-seperator-d731s`,
	"boxseperator": `QuoteSection-boxseperator-zUFgC`,
	"mainhedding": `QuoteSection-mainhedding-wAriP`,
	"common": `QuoteSection-common-Tnax2`,
	"quotesection": `QuoteSection-quotesection-kmBBB`,
	"contentarea": `QuoteSection-contentarea-bZA2s`,
	"imagearea": `QuoteSection-imagearea-MRblM`,
	"qutoIcon": `QuoteSection-qutoIcon-YQ6FE`,
	"qutoSize": `QuoteSection-qutoSize-eHhoc`,
	"quotesectionH2": `QuoteSection-quotesectionH2-SeeuV`,
	"rightsidecontent": `QuoteSection-rightsidecontent-DHQp1`,
	"btnlearn": `QuoteSection-btnlearn-nhJMS`,
	"leftsidecontent": `QuoteSection-leftsidecontent-rn4AF`,
	"iconCss": `QuoteSection-iconCss-b10SG`,
	"textarea": `QuoteSection-textarea-HUzCo`,
	"centerimgsection": `QuoteSection-centerimgsection-YKibl`
};
module.exports = ___CSS_LOADER_EXPORT___;
